/*=========================================================
 * Module: dates-in-timezone.js
 * Services to convert the dates to a current client timezone
   e.g. start is 2018-10-07T04:00:00.000Z
   end is 2018-10-24T03:59:59.000Z
   where +4:00 shift because of a current client timezone (America/New_York)
 =========================================================*/

App.service("datesInTimezone", function ($rootScope) {
  return {
    convertToInstTimezone(from_date, to_date, to_iso = true) {
      if (!$rootScope.timezone) {
        return false;
      }

      converted_date_start = moment(from_date).startOf("day");
      converted_date_end = moment(to_date).endOf("day");
      converted_date_start_offset = converted_date_start.utcOffset();
      converted_date_end_offset = converted_date_end.utcOffset();
      converted_date_start = moment.tz(converted_date_start, $rootScope.timezone);
      converted_date_start.add(converted_date_start_offset - converted_date_start.utcOffset(), "minutes");
      converted_date_end = moment.tz(converted_date_end, $rootScope.timezone);
      converted_date_end.add(converted_date_end_offset - converted_date_end.utcOffset(), "minutes");
      if (to_iso) {
        return [converted_date_start.toISOString(), converted_date_end.toISOString()];
      } else {
        return [converted_date_start, converted_date_end];
      }
    },
    convertFromUserToLocTimezone(date, to_iso = true) {
      converted_date = moment(date);
      converted_date_offset = converted_date.utcOffset();
      converted_date = moment.tz(converted_date, $rootScope.timezone);
      timezone_offset_in_minutes = this.getTimezoneOffset(new Date(date), $rootScope.timezone, false) * 60;
      timezone_offset_string = this.getTimezoneOffset(new Date(date), $rootScope.timezone, true);
      converted_date.add(converted_date_offset - timezone_offset_in_minutes, "minutes");
      converted_date.utcOffset(timezone_offset_string)
      if (to_iso) {
        return converted_date.toISOString();
      } else {
        return converted_date;
      }
    },
    ignoreTimezone(date, to_string = false) {
      converted_date = moment(date);
      if (to_string) {
        return converted_date.format("YYYY-MM-DDTHH:mm:ss") + "Z";
      } else {
        return new Date(converted_date.utcOffset(0).format("YYYY-MM-DDTHH:mm:ss"));
      }
    },
    convertFromUtcToLocalTimezone(date, to_iso = true) {
      timezone_offset_in_minutes = this.getTimezoneOffset(new Date(date), $rootScope.timezone, false) * 60;
      converted_date = moment(date);
      converted_date = moment.tz(converted_date, $rootScope.timezone);
      converted_date.add(timezone_offset_in_minutes, "minutes");
      timezone_offset_string = this.getTimezoneOffset(new Date(date), $rootScope.timezone);

      iso_string = converted_date.toISOString().split('.')[0] + timezone_offset_string;
      if (to_iso) {
        return iso_string;
      } else {
        return moment(iso_string);
      }
    },
    convertFromUtcToLocationTimezone(date) {
      // Get the offset from local to the location's timezone
      timezone_offset_in_minutes =
        this.getTimezoneOffset(new Date(date), $rootScope.timezone, false) * 60

      converted_date = moment
        .tz(moment(date), $rootScope.timezone)
        .add(timezone_offset_in_minutes, "minutes")

      // Strip the timezone offset from the ISO string
      iso_string_without_timezone = converted_date.toISOString().split(".")[0]
      return iso_string_without_timezone
    },
    getTimezoneOffset(date, tz, to_string = true) {
      // adapted from: https://stackoverflow.com/questions/36112774/calculate-the-utc-offset-given-a-timezone-string-in-javascript
      // return timezone offset in hours on a specific date
      // exmaples:
      // getTimezoneOffset(new Date(2023, 2, 1), "America/New_York") => -05:00
      // getTimezoneOffset(new Date(2023, 2, 15), "America/New_York") => -04:00
      // getTimezoneOffset(new Date(2023, 2, 15), "Europe/Moscow") => 03:00

      const splitDate = date.toLocaleString("ja", {timeZone: tz}).split(/[/\s:]/);
      splitDate[1]--;
      const t1 = Date.UTC.apply(null, splitDate);
      const t2 = new Date(date).setMilliseconds(0);
      const offset = -1 * ((t2 - t1) / 60 / 1000 / 60);
      if (!to_string) return offset

      return offset.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      }) + ":00"
    }
  };
});
